import React from 'react';
import { Routes, Route } from "react-router-dom";
import CheckerReportsModule from "./ca-checker-reports-module/checker-reports-module";

const Checker_Reports = () => {
  return (
    <Routes>
      <Route index element={<CheckerReportsModule />} />
    </Routes>
  )
}

export default Checker_Reports;



